module.exports = __webpack_public_path__ + "components/rewards/coolbus/static/logo-8f3dacb3ec4b545247ad36a51c80dae9.webp";